var _rect, _rect2, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#36A6A4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4084",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#36A6A4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.0001C0.280051 10.2846 -2.16667 10.6667 -3 11.0001V13.5C-1.83333 13.5 0.631789 14.0439 2 14.5C8 16.5 11 15 13 12.5C14.8019 10.2476 18.6667 4.16667 20 1L12.5 -1.5L10 6.5C9.16667 8.33336 8 12 3.5 11.0001Z",
    fill: "#179593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.5001C7.28005 17.7846 -0.666667 17.6667 -1.5 18L0 19.5C1.16667 19.5 7.5 20.5 9 22C13.4721 26.4721 18 22.5 20 20C21.8019 17.7476 25.6667 11.6667 27 8.5L23 4L17.5 14C16 16 15 19.5 10.5 18.5001Z",
    fill: "#179593"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45801 11.299C8.45801 9.38237 10.0596 7.83325 11.9969 7.83325C13.9397 7.83325 15.5413 9.38237 15.5413 11.299C15.5413 12.2648 15.1901 13.1614 14.612 13.9214C13.9742 14.7597 13.1881 15.4901 12.3032 16.0634C12.1007 16.1959 11.918 16.2059 11.6957 16.0634C10.8058 15.4901 10.0197 14.7597 9.38738 13.9214C8.80883 13.1614 8.45801 12.2648 8.45801 11.299ZM10.8306 11.4069C10.8306 12.049 11.3545 12.5539 11.9969 12.5539C12.6398 12.5539 13.1687 12.049 13.1687 11.4069C13.1687 10.7698 12.6398 10.2403 11.9969 10.2403C11.3545 10.2403 10.8306 10.7698 10.8306 11.4069Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.722bd40255da1d144f6a8f15889719e8.svg";
export { ForwardRef as ReactComponent };